import React from 'react';

import { Label, RowContainer, StyledText } from './styles';

interface DataRowProps {
  value: string | number | string[] | undefined;
}

const DataRowNote: React.FC<DataRowProps> = ({ value }) => {
  return (
    <RowContainer>
      <Label></Label>
      <StyledText>{value}</StyledText>
    </RowContainer>
  );
};

export default DataRowNote;
